import type { ExteriorColorView } from "@slfinrtl/ui-bff-routes"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import type { OrderType } from "../../OrderType"
import { SelectCatalogExteriorColor } from "../../components/SelectCatalogExteriorColor"
import { SelectCatalogExteriorColorSkeleton } from "../../components/SelectCatalogExteriorColorSkeleton"
import { useSelectCatalogExteriorColor } from "./useSelectCatalogExteriorColor"

export interface SelectCatalogExteriorColorContainerProps {
	currentExteriorColor: ExteriorColorView | undefined
	inventoryId: string
	onExteriorColorSelected: (exteriorColor: ExteriorColorView) => void
	orderType: OrderType
	showCustomExteriorColorContainer: () => void
}

export const SelectCatalogExteriorColorContainer = withErrorHandler(
	(props: SelectCatalogExteriorColorContainerProps) => {
		const viewProps = useSelectCatalogExteriorColor(props)

		return (
			<>
				<ErrorNotificationInline />
				{viewProps ? <SelectCatalogExteriorColor {...viewProps} /> : <SelectCatalogExteriorColorSkeleton />}
			</>
		)
	},
)
